module.exports = __webpack_public_path__ + "img/sup_wallet_3.5f721250.jpg";